// Copyright (c) 2019 Deere & Company

import './modal.scss';
import { FormattedMessage } from 'react-intl';
import Modal from 'react-bootstrap/Modal';
import PropTypes from 'prop-types';
import React from 'react';

export const CancelOnlyModal = props => (
    <div className="confirmation-modal">
        <Modal dialogClassName={props.className} backdrop={true} onHide={props.onHide} show={props.isOpen} size="sm">
            <Modal.Header>{props.header}</Modal.Header>
            <Modal.Body>
                {props.body}
            </Modal.Body>
            <Modal.Footer>
                <button type="button" onClick={props.onCancel}>
                    <FormattedMessage id="CANCEL" />
                </button>
            </Modal.Footer>
        </Modal>
    </div>
);

CancelOnlyModal.propTypes = {
    body: PropTypes.node.isRequired,
    header: PropTypes.node.isRequired,
    isOpen: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    onHide: PropTypes.func.isRequired,
    className: PropTypes.string,
};
